export enum TimelineSectionStatus {
  New = 'New',
  Saved = 'Saved',
  Submitted = 'Submitted',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Delete = 'Delete',
  Unlock = 'Unlock'
}
